import serviceRequest from "utils/request";

const baseUrl = "/api/user";

export const changePwd = (param) => {
	return serviceRequest({
		url: `${baseUrl}/change-password`,
		method: "post",
		data: param,
	});
};

export const resetUserPassword = (param) => {
	return serviceRequest({
		url: `${baseUrl}/reset-user-password`,
		method: "post",
		data: param,
	});
};
export const resetPwdFirstLogin = (param) => {
	return serviceRequest({
		url: `${baseUrl}/reset-pwd-first-login`,
		method: "post",
		data: param,
	});
};

export const forgetPwdSendEmail = (param) => {
	return serviceRequest({
		url: `${baseUrl}/forget-password/send-email`,
		method: "post",
		data: { userEmail: param.userEmail },
	});
};
